var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact_form"},[_c('form',{attrs:{"autocomplete":"off","action":"https://docs.google.com/forms/u/1/d/e/1FAIpQLSeudVI9Q_MqDqm6dm1W7vkKHCL2BNOWFO_ejnFCoOayQd9m1A/formResponse?embedded=true","method":"POST"},on:{"submit":_vm.validateForm}},[_c('Textfield',_vm._b({},'Textfield',{
              callback:function (val){_vm.callbackFormField(val,'name')},
              label:'Name',
              type:'text',
              inputValue:_vm.formPayload.name.value,
              errorMsg:_vm.formPayload.name.error,
              id:'name',
              name:'entry.1902652876',
              required:true,
              },false)),_c('Textfield',_vm._b({},'Textfield',{
              callback:function (val){_vm.callbackFormField(val,'email')},
              label:'E-mail address',
              type:'text',
              inputValue:_vm.formPayload.email.value,
              errorMsg:_vm.formPayload.email.error,
              id:'email',
              name:'entry.1612974425',
              required:true
              },false)),_c('Textfield',_vm._b({},'Textfield',{
              callback:function (val){_vm.callbackFormField(val,'mobile')},
              label:'Mobile number',
              type:'text',
              inputValue:_vm.formPayload.mobile.value,
              errorMsg:_vm.formPayload.mobile.error,
              id:'mobile',
              name:'entry.348021927',
              required:true
              },false)),_c('Textfield',_vm._b({},'Textfield',{
              callback:function (val){_vm.callbackFormField(val,'message')},
              label:'What’s your project about?',
              type:'text',
              inputValue:_vm.formPayload.message.value,
              errorMsg:_vm.formPayload.message.error,
              id:'message',
              name:'entry.1181796856',
              required:false
              },false)),_c('input',{staticClass:"button big-btn",attrs:{"type":"submit","value":"Get in touch"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }